import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUserId } from './UserUtils';
import { ACCESS_LEVELS } from '../constants/AccessLevels';

// Utilities for when a user selects/deselects asset access levels, e.g. everyone, private, or selected users and teams
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultDisableAccessToEveryoneFormattedMessage = ({
  teamName
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ui-asset-management-lib.tooltips.disableAccessToEveryoneTooltip",
    options: {
      teamName
    }
  });
};
export const getCurrentAccessLevel = ({
  assignedUserIds,
  assignedTeamIds,
  assignedAccessLevel,
  disableAccessToEveryone
}) => {
  const onlyCurrentUserAllowed = assignedTeamIds.length === 0 && assignedUserIds.length === 1 && assignedUserIds.includes(getUserId());
  if (disableAccessToEveryone) {
    if (assignedAccessLevel && ![ACCESS_LEVELS.EVERYONE, ACCESS_LEVELS.EVERYONE_VIEW_ONLY, ACCESS_LEVELS.EVERYONE_VIEW_AND_EDIT].includes(assignedAccessLevel)) {
      return assignedAccessLevel;
    }
    return onlyCurrentUserAllowed ? ACCESS_LEVELS.PRIVATE : ACCESS_LEVELS.SELECTED_USERS_AND_TEAMS;
  }

  // If assignedAccessLevel is passed in, override rest of logic checks
  if (assignedAccessLevel) {
    return assignedAccessLevel;
  }
  if (assignedUserIds.length === 0 && assignedTeamIds.length === 0) {
    return ACCESS_LEVELS.EVERYONE;
  }
  if (onlyCurrentUserAllowed) {
    return ACCESS_LEVELS.PRIVATE;
  }
  return ACCESS_LEVELS.SELECTED_USERS_AND_TEAMS;
};